// src/components/modals/AvoidTaskModal.tsx
import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input } from "reactstrap";

interface AvoidTaskModalProps {
  isOpen: boolean;
  toggle: () => void;
  comment: string;
  setComment: (text: string) => void;
  onConfirm: () => void;
  reproveStateName: string;
}

const AvoidTaskModal: React.FC<AvoidTaskModalProps> = ({
  isOpen, toggle, comment, setComment, onConfirm, reproveStateName
}) => (
  <Modal isOpen={isOpen} toggle={toggle} className={`${localStorage.getItem("mode") ? localStorage.getItem("mode") : "light"}`}>
    <ModalHeader className="modal-header-style theme-text-color" toggle={toggle}>
      Mover para o status predecessor {reproveStateName ? `(${reproveStateName})` : ""}
    </ModalHeader>
    <ModalBody className="modal-body-style">
      <Input
        type="textarea"
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        rows={8}
        placeholder="Explique o motivo..."
        className="input-modal theme-text-color"
      />
    </ModalBody>
    <ModalFooter className="modal-footer-style">
      <Button color="primary" onClick={onConfirm} id="btn-avoid-task">Confirmar</Button>
      <Button color="secondary" onClick={toggle}>Cancelar</Button>
    </ModalFooter>
  </Modal>
);

export default AvoidTaskModal;
